import { useState } from "react";

import { Pen, X } from "lucide-react";

import { Modal } from "@/shared/ui/Modal";
import { AddCommissionExclusionModal } from "./ui/AddCommissionExclusionModal";
import {
  useCommissionExclusions,
  useDeactivateCommissionExclusion,
  WorkerCommissionExclusionStatus,
} from "@/entities/worker";
import { useURLParamsData } from "@/shared/hooks";
import { localizationMap, PAGE_SIZE } from "@/shared/lib/consts";
import { Roles } from "@/entities/user";

type MotiveGridModalProps = {
  userId: string;
  nickname: string;
  role: Roles;
};

export const MotiveGridModal = ({
  userId,
  nickname,
  role,
}: MotiveGridModalProps) => {
  const [open, setOpen] = useState(false);

  const { page } = useURLParamsData();

  const { data } = useCommissionExclusions({
    currentPage: page,
    pageSize: PAGE_SIZE,
    workerIds: [userId],
    enabled: open,
  });
  const { mutateAsync } = useDeactivateCommissionExclusion();

  return (
    <Modal open={open} onOpenChange={setOpen}>
      <Modal.Trigger variant="outline">
        <Pen />
      </Modal.Trigger>
      <Modal.Content>
        <Modal.Title>Мотивационная сетка</Modal.Title>
        <div className="flex gap-7">
          <div className="flex flex-1 flex-col gap-2">
            <p className="text-sm text-thColor">Ник</p>
            <p className="font-semibold">{nickname}</p>
          </div>
          <div className="flex flex-1 flex-col gap-2">
            <p className="text-sm text-thColor">Роль</p>
            <p className="font-semibold">{localizationMap[role]}</p>
          </div>
        </div>
        <div className="flex flex-col gap-4">
          <p className="text-sm text-thColor">Список ограничений</p>
          <div className="flex w-full flex-col gap-4 rounded-lg bg-muted p-4 text-sm">
            <div className="flex justify-between">
              <p className="text-thColor">Причина</p>
              <p className="text-thColor">Коммент</p>
            </div>
            {data?.data
              .filter(
                (item) =>
                  item.status === WorkerCommissionExclusionStatus.ACTIVE,
              )
              .map((exclusion) => (
                <div className="flex justify-between" key={exclusion.id}>
                  <div className="flex items-center gap-2">
                    <button onClick={() => mutateAsync({ id: exclusion.id })}>
                      <X className="text-thColor" size={10} />
                    </button>
                    <p className="text-[#0c0c0c]">
                      {localizationMap[exclusion.reason]}
                    </p>
                  </div>
                  <p className="text-[#0c0c0c]">{exclusion.comment}</p>
                </div>
              ))}
          </div>
          <AddCommissionExclusionModal workerId={userId} />
        </div>
        <Modal.Close />
      </Modal.Content>
    </Modal>
  );
};
